import localeadd3f80a from '../../lang/de-CH.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"de_CH"},
  vueI18nLoader: false,
  locales: [{"code":"de_CH","name":"Deutsch (Schweiz)","iso":"de-CH","file":"de-CH.json","isCatchallLocale":true}],
  defaultLocale: "de_CH",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"de_CH","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  seo: false,
  normalizedLocales: [{"code":"de_CH","name":"Deutsch (Schweiz)","iso":"de-CH","file":"de-CH.json","isCatchallLocale":true}],
  localeCodes: ["de_CH"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "d",
  3: "e",
  4: "-",
  5: "C",
  6: "H",
  7: ".",
  8: "j",
  9: "s",
  10: "o",
  11: "n",
  12: "\"",
  13: ":",
  14: "\"",
  15: ".",
  16: ".",
  17: "/",
  18: "l",
  19: "a",
  20: "n",
  21: "g",
  22: "/",
  23: "d",
  24: "e",
  25: "-",
  26: "C",
  27: "H",
  28: ".",
  29: "j",
  30: "s",
  31: "o",
  32: "n",
  33: "\"",
  34: "}",
}

export const localeMessages = {
  'de-CH.json': () => Promise.resolve(localeadd3f80a),
}
